import { gql } from "@apollo/client";

/**
 * Passwordless sign-in: phone, then the OTP sent to it.
 *
 * NOT a new authentication path. These two mutations are the SAME ones the AppZap mobile app
 * already uses, and the whole flow lives server-side in confirmSignInSignUpSvc: it verifies
 * the OTP, writes a login history row, and issues tokens through createToken — the identical
 * function the username/password login uses.
 *
 * It exists here because shops created by AppZap have no password at all, so there was no way
 * to reach the admin web as one of them.
 */
export const APP_V2_REQUEST_OTP = gql`
  mutation AppV2SignInSignUp($where: LoginPhoneInput!) {
    appV2SignInSignUp(where: $where) {
      status
      msg
      otpExpire
      tag
    }
  }
`;

/**
 * `password` carries the OTP — the backend resolver maps `where.password` onto `otp`. Named
 * that way by the shared LoginPhoneInput, not by choice.
 */
export const APP_V2_CONFIRM_OTP = gql`
  mutation AppV2ConfirmSignInSignUp($where: LoginPhoneInput!) {
    appV2ConfirmSignInSignUp(where: $where) {
      status
      msg
      token {
        accessToken
        refreshToken
        tokenExDate
        refreshTokenExDate
      }
      data {
        id
        nickname
        phone
        role
        gender
        shop {
          id
        }
        username
        email
        isConfirmed
        createdAt
        updatedAt
      }
    }
  }
`;
